import { PageTemplate } from '@/common/PageWrapper';
import React from 'react';
import { Link } from 'react-router';

const CoursePage = () => {
  return (
    <PageTemplate>
      <div className="px-4 sm:px-6 md:px-16 py-4">
        <main className="w-full py-4 md:py-8">
          {/* Course Header */}
          <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-8 md:gap-12 mb-12 md:mb-16">
            <div className="flex flex-col justify-center order-2 lg:order-1">
              <div className="mb-3 md:mb-4">
                <span
                  className="px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-medium"
                  style={{ backgroundColor: '#D1E7DD', color: '#184D47' }}
                >
                  Level Pemula
                </span>
              </div>
              <h1 className="text-2xl md:text-5xl font-semibold mb-4 md:mb-6" style={{ color: '#184D47' }}>
                Kursus Digital Marketing
              </h1>
              <p className="text-base md:text-xl font-normal text-gray-700 mb-6 md:mb-8 leading-relaxed max-w-4xl">
                Kursus ini membekali peserta dengan keterampilan inti digital marketing.
                Materinya mencakup iklan berbayar, media sosial, email marketing, SEO, dan analisis web.
                Peserta akan mampu merancang dan mengelola kampanye pemasaran digital secara efektif.
                Dengan pembelajaran praktis, peserta dapat langsung menerapkan strategi yang dipelajari
                untuk mencapai target bisnis.
              </p>

              <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-6 mb-6 md:mb-8">
                <Link to={"/course1"}>
                  <button
                    className="px-4 py-3 md:px-20 md:py-4 rounded-md font-semibold transition-colors text-base md:text-lg w-full sm:w-auto text-center"
                    style={{ backgroundColor: '#184D47', color: 'white' }}
                  >
                    Mulai Kelas
                  </button>
                </Link>

                <div
                  className="flex items-center justify-center px-4 py-3 md:px-8 md:py-4 rounded-md w-full sm:w-auto"
                  style={{ backgroundColor: '#184D47', color: 'white' }}
                >
                  <span className="font-semibold text-base md:text-lg">4 Modul</span>
                </div>

                <div
                  className="flex items-center justify-center px-4 py-3 md:px-8 md:py-4 rounded-md w-full sm:w-auto"
                  style={{ backgroundColor: '#184D47', color: 'white' }}
                >
                  <span className="font-semibold mr-2 text-base md:text-lg">4.5</span>
                  <svg width="20" height="21" viewBox="0 0 16 17" fill="none" className="mr-2">
                    <path d="M3.09967 13.8215L4.264 9.01002L0.392578 5.77518L5.4922 5.34954L7.48941 0.811523L9.48663 5.34863L14.5853 5.77427L10.7139 9.00911L11.8792 13.8206L7.48941 11.2668L3.09967 13.8215Z" fill="#FFB648" />
                  </svg>
                  <span className="text-sm">(123 ulasan)</span>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center w-full h-full order-1 lg:order-2 mb-6 md:mb-0">
              <img
                src="https://images.unsplash.com/photo-1586880244406-556ebe35f282?auto=format&fit=crop&w=800&q=80"
                alt="Introduction to Social Media Marketing"
                className="w-full h-64 md:h-[500px] object-cover rounded-xl"
              />
            </div>
          </div>

          {/* Benefits Section */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-semibold mb-6 md:mb-10" style={{ color: '#184D47' }}>Benefit</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { title: "Digital Marketing", desc: "Strategi pemasaran digital komprehensif" },
                { title: "Pay Per Click Advertising", desc: "Pengelolaan iklan berbasis klik" },
                { title: "Email Marketing", desc: "Strategi pemasaran melalui email efektif" },
                { title: "SEO Optimization", desc: "Teknik optimasi mesin pencari" }
              ].map((benefit, idx) => (
                <div
                  key={idx}
                  className="p-4 md:p-8 bg-white rounded-xl shadow-sm transition-all hover:scale-[1.02]"
                  style={{ border: '1px solid #184D47' }}
                >
                  <h3 className="font-semibold mb-2 md:mb-3 text-base md:text-xl" style={{ color: '#184D47' }}>
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-base">{benefit.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Course Modules */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-semibold mb-6 md:mb-10" style={{ color: '#184D47' }}>
              Digital Marketing untuk Pemula
            </h2>

            <div className="space-y-4 md:space-y-6">
              {[
                { title: "Digital Marketing Foundations", duration: "Modul 01 | 2 jam untuk diselesaikan" },
                { title: "Display Advertising", duration: "Modul 02 | 3 jam untuk diselesaikan" },
                { title: "Email Marketing", duration: "Modul 03 | 1 jam untuk diselesaikan" },
                { title: "Social Media Marketing", duration: "Modul 04 | 2 jam untuk diselesaikan" }
              ].map((mod, idx) => (
                <div
                  key={idx}
                  className="flex flex-col md:flex-row justify-between items-start p-4 md:p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-all"
                  style={{ border: '1px solid #184D47' }}
                >
                  <div className="w-full md:w-3/4 mb-3 md:mb-0">
                    <h3 className="text-base md:text-2xl font-semibold mb-1 md:mb-3" style={{ color: '#184D47' }}>
                      {mod.title}
                    </h3>
                    <p className="text-gray-600 text-base">{mod.duration}</p>
                  </div>
                  <div className="w-full md:w-auto flex justify-start md:justify-end">
                    <button
                      className="px-4 py-2 md:px-6 md:py-3 rounded-md text-base md:text-lg"
                      style={{ backgroundColor: '#184D47', color: 'white' }}
                    >
                      5 Video
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </PageTemplate>
  );
};

export default CoursePage;